"use client";

import { useLinkStatus } from "next/link";
import React from "react";
import { cn } from "../../../../helpers/classNames";
import { SpinningSun } from "../../../SpinningSun";
import styles from "./styles.module.scss";

type Props = {
    label: string;
};

export const ItemInner: React.FC<Props> = ({ label }) => {
    const { pending } = useLinkStatus();

    return (
        <>
            {pending && (
                <SpinningSun size={24} className={styles.isLoadingSun} />
            )}
            <div className={cn(pending && styles.isLoadingLabel)}>{label}</div>
        </>
    );
};
